import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import { ProductBlockGrid } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
import { usePlpDatalayerEvents } from "../../../../DataLayer/hooks/DataLayer/hooks/use-plp-datalayer-events.js";
import { usePromoIndices } from "./use-promo-indices.js";
import { PromotionBlock } from "../../../../lib-components/PromotionBlock/lib-components/PromotionBlock/PromotionBlock.js";
import { ProductListingBlockWrapper } from "../../components/ProductListingBlockWrapper/ProductListing/ProductListingPage/components/ProductListingBlockWrapper/ProductListingBlockWrapper.js";
const ProductListingPage = ({
  products,
  pageSize,
  pageNumber,
  promotionSmall,
  promotionBig,
  reimbursableLogos,
  isPriceSuffixEnabled,
  indexName
}) => {
  const { getLabel } = useIntl();
  const { pushImpressionsToDatalayer, addImpressionEvent, pushProductClickToDatalayer } = usePlpDatalayerEvents();
  const { smallPromoIndex, bigPromoIndex } = usePromoIndices(products.length, !!promotionSmall);
  const isSmallScreen = MediaQuery.useIsPhone();
  const dividerLabel = `${getLabel("common.page")} ${pageNumber}`;
  const showPromos = products.length >= pageSize;
  React.useEffect(() => {
    pushImpressionsToDatalayer();
  }, []);
  const augmentedProductList = React.useMemo(() => {
    return products.reduce((result, product, index) => {
      if (showPromos && !!promotionSmall && result.length === smallPromoIndex) {
        const smallPromoIdentifier = "promo-small";
        result.push(
          /* @__PURE__ */ React.createElement(ProductBlockGrid.Cell, { key: smallPromoIdentifier, isWide: isSmallScreen }, /* @__PURE__ */ React.createElement(
            PromotionBlock,
            {
              ...promotionSmall,
              id: smallPromoIdentifier,
              size: isSmallScreen ? "large" : "small",
              ctaLabel: promotionSmall.links?.label ?? ""
            }
          ))
        );
      }
      if (showPromos && !!promotionBig && result.length === bigPromoIndex) {
        const bigPromoIdentifier = "promo-big";
        result.push(
          /* @__PURE__ */ React.createElement(ProductBlockGrid.Cell, { key: bigPromoIdentifier, isWide: true }, /* @__PURE__ */ React.createElement(
            PromotionBlock,
            {
              ...promotionBig,
              id: bigPromoIdentifier,
              size: "large",
              ctaLabel: promotionBig.links?.label ?? ""
            }
          ))
        );
        result.push(null);
      }
      if (!product) {
        result.push(/* @__PURE__ */ React.createElement(ProductBlockGrid.Cell, { key: index }, ""));
      }
      if (product) {
        const showPriceSuffix = isPriceSuffixEnabled && product.isOfferedWithPrescriptions;
        result.push(
          /* @__PURE__ */ React.createElement(ProductBlockGrid.Cell, { key: product.masterVariant.sku }, /* @__PURE__ */ React.createElement(
            ProductListingBlockWrapper,
            {
              product,
              index,
              indexName,
              reimbursableLogos,
              addImpressionEvent,
              pushProductClickToDatalayer,
              isPriceSuffixEnabled: showPriceSuffix
            }
          ))
        );
      }
      return result;
    }, []);
  }, [
    products,
    indexName,
    showPromos,
    promotionSmall,
    smallPromoIndex,
    promotionBig,
    bigPromoIndex,
    isSmallScreen,
    isPriceSuffixEnabled,
    reimbursableLogos,
    addImpressionEvent,
    pushProductClickToDatalayer
  ]);
  return /* @__PURE__ */ React.createElement(
    ProductBlockGrid.Container,
    {
      "data-t": `product-listing-page-${pageNumber}`,
      hasDivider: pageNumber !== 1
    },
    pageNumber !== 1 && /* @__PURE__ */ React.createElement(ProductBlockGrid.Divider, null, dividerLabel),
    /* @__PURE__ */ React.createElement(
      ProductBlockGrid.Grid,
      {
        hasSmallPromo: showPromos && !!promotionSmall,
        hasBigPromo: showPromos && !!promotionBig
      },
      augmentedProductList
    )
  );
};
export {
  ProductListingPage,
  ProductListingPage as default
};
//# sourceMappingURL=ProductListingPage.js.map
